export const TWITTER_URL = 'https://twitter.com/artificiallabs'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/artificiallabs/'
export const TEAMTAILOR_API_URL = 'https://api.teamtailor.com/v1/jobs'
